import { Component, OnInit, Input, OnChanges, ViewChild } from '@angular/core';
import { VerticalNaaService } from 'src/app/vertical/naa/shared/vertical-naa.service';
import { NaaProfileTypeOwnerDto } from 'src/app/vertical/naa/shared/dto/naa-profile-type-owner.dto';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'wl-profile-type-owner-edit',
  templateUrl: './profile-type-owner-edit.component.html',
  styleUrls: ['./profile-type-owner-edit.component.less'],
    standalone: false
})
export class ProfileTypeOwnerEditComponent implements OnInit, OnChanges {
  @Input() profileId: number;
  @ViewChild('overrideForm') overrideForm: NgForm;
  profileTypeOwnerDto: NaaProfileTypeOwnerDto;
  unitsInPortfolioOverride: number;

  constructor(private _verticalNaaService: VerticalNaaService) {}

  ngOnInit(): void {}

  ngOnChanges() {
    if (this.profileId) {
      this._verticalNaaService.getProfileTypeOwnerForProfileId(this.profileId).then((profileType) => {
        this.profileTypeOwnerDto = profileType;
        this.profileTypeOwnerDto.ProfileId = this.profileId;
        this.unitsInPortfolioOverride = profileType.TotalUnitsInPortfolio;
      });
    }
  }

  overrideChanged() {
    this.profileTypeOwnerDto.TotalUnitsInPortfolioOverridden =
      this.unitsInPortfolioOverride !== this.profileTypeOwnerDto.TotalUnitsInPortfolio;
  }

  public save() {
    let promise: Promise<number | void>;
    if (this.profileTypeOwnerDto.TotalUnitsInPortfolioOverridden) {
      this.profileTypeOwnerDto.TotalUnitsInPortfolio = this.unitsInPortfolioOverride;
    }
    if (this.profileTypeOwnerDto.Id > 0 && this.overrideForm?.dirty) {
      promise = this._verticalNaaService.updateProfileTypeOwner(this.profileTypeOwnerDto);
    } else if (this.profileTypeOwnerDto.Id === 0) {
      promise = this._verticalNaaService.createProfileTypeOwner(this.profileTypeOwnerDto);
    } else {
      promise = Promise.resolve();
    }
    this.overrideForm?.form.markAsPristine();
    return promise;
  }
}
